import React, { Component } from 'react';
import _ from 'lodash';
import Immutable from 'immutable';
import FilterTable from '../../common/FilterTable';
import { AssociatedCasesView } from './AssociatedCasesView';
import { RelatedCases } from './RelatedCases';
import { OtherFilings } from './OtherFilings';

export class AllCasesView extends Component {
  getTableBody = (data, label) => {
    if (label === 'associated_cases') {
      return (<AssociatedCasesView associatedCases={data} key="associate-cases" />);
    }

    if (label === 'related_cases_district') {
      return (<RelatedCases relatedCases={data} key="related-cases" />);
    }

    if (label === 'other_filings') {
      return (<OtherFilings otherFilings={data} key="other-cases" />);
    }

    return null;
  };

  render() {
    const { cases, case_uuid } = this.props;

    const firstEntry = _.get(cases, '[0][1]') || [];
    const secondEntry = _.get(cases, '[1][1]') || [];
    const thirdEntry = _.get(cases, '[2][1]') || [];

    let tableData = [
      {
        label: _.get(cases, '[0][0]') || '',
        entry: Immutable.Iterable.isIterable(firstEntry) ? firstEntry.toJS() : firstEntry,
      },
      {
        label: _.get(cases, '[1][0]'),
        entry: Immutable.Iterable.isIterable(secondEntry) ? secondEntry.toJS() : secondEntry,
      },
      {
        label: _.get(cases, '[2][0]'),
        entry: Immutable.Iterable.isIterable(thirdEntry) ? thirdEntry.toJS() : thirdEntry,
      },

    ];
    tableData = _.sortBy(tableData, 'label');

    const totalEntries = tableData.filter(p => Array.isArray(p.entry) && p.entry.length > 0)
    const header = 'Associated Cases';
    if (totalEntries.length < 1) {
      const asso_obj = _.find(tableData, function (obj) { return obj.label === 'associated_cases';});
      const emptyMsg = _.get(asso_obj, 'asso_obj.entry.empty', 'There are no associations for this case.');
      return (
        <div className="associated-cases">
          <h2 className="case-label">{ header }</h2>
          <div className="ir-search-status-message messages warning">
            { emptyMsg }
          </div>
        </div>
      );
    }

    return (
      <div>
        <FilterTable
          showHeader={totalEntries.length > 0}
          premiumSearch={{ uuid: case_uuid, query: 'associated_cases' }}
        >
          <div className="associated-cases">
            <h2 className="case-label">{ header }</h2>
          </div>
          { tableData.map(p => this.getTableBody(p.entry, p.label)) }
        </FilterTable>
      </div>
    );
  }
}

export default AllCasesView;



/** WEBPACK FOOTER **
 ** ./src/components/case/associated_cases/AllCasesView.js
 **/